import type { Distance, Margins, SpatialRectangle } from "@pdfking/math"
import { RemoveMargins, Scale, Subtract, Total } from "@pdfking/math"
import { ToPixel } from "@pdfking/quantity"
import type { PageShape } from "@pdfking/renderer-api"
import { HorizontalAlign, PlotFunction, VerticalAlign } from "@pdfking/renderer-api"
import type { StringGUID } from "@pdfking/tfunc"

import { PALETTE, PUBLISHER } from "#constants"

import { DrawPlate } from "../layout/DrawPlate"
import { PageMetrics } from "../layout/PageMetrics"
import { DrawBackpackGrid } from "../pattern/DrawBackpackGrid"
import { CreateRandom } from "../random/CreateRandom"

// The back of the cover in `box`: the pattern in paper and the secondary on
// the primary, and at the foot of `security` a plate, like the ex libris one,
// with the publisher and where it printed; the pattern runs on into `bleed`
export const DrawBackCover = ({
  bleed,
  box,
  security,
  seed,
}: {
  bleed: Margins<Distance>
  box: SpatialRectangle<Distance>
  security: Margins<Distance>
  seed: StringGUID
}): PageShape[] => {
  const { font_size, short } = PageMetrics(box)
  const frame = RemoveMargins(box, security)
  const width = Scale(short, 0.5)
  const plate = {
    height: Scale(short, 0.16),
    width,
    x: Total(frame.x, Scale(Subtract(frame.width, width), 0.5)),
    y: frame.y,
  }
  return [
    ...DrawBackpackGrid({
      bleed,
      box,
      ground: PALETTE.primary,
      inks: [PALETTE.paper, PALETTE.secondary],
      random: CreateRandom(seed, "back cover"),
      short,
    }),
    ...DrawPlate({
      box: plate,
      draw: inside => {
        const inside_top = Total(inside.y, inside.height)
        return [
          { below: Scale(short, 0.025), size: Scale(font_size, 0.9), text: PUBLISHER },
          { below: Scale(short, 0.07), size: Scale(font_size, 0.8), text: "IMPRESSUM ROMAE" },
        ].map(({ below, size, text }): PageShape => ({
          enum: PlotFunction.PLOT_TEXT,
          font_size: ToPixel(size),
          horizontal_align: HorizontalAlign.CENTER,
          position: { ...inside, height: size, y: Subtract(inside_top, Total(below, size)) },
          text,
          text_color: PALETTE.text,
          vertical_align: VerticalAlign.TOP,
        }))
      },
      short,
    }),
  ]
}
